/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/schConferences/schConferencesActions";
import { useSchConferencesUIContext } from "../SchConferencesUIContext";

export function SchConferenceDeleteDialog({ id, show, onHide }) {
  // SchConferences UI Context
  const schConferencesUIContext = useSchConferencesUIContext();
  const schConferencesUIProps = useMemo(() => {
    return {
      setIds: schConferencesUIContext.setIds,
      queryParams: schConferencesUIContext.queryParams,
    };
  }, [schConferencesUIContext]);

  // SchConferences Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schConferences.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchConference = () => {
    // server request for deleting schConference by id
    dispatch(actions.deleteSchConference(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchConferences(schConferencesUIProps.queryParams));
      // clear selections list
      schConferencesUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchConference Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schConference?</span>
        )}
        {isLoading && <span>SchConference is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchConference}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
